/** 受注方法（依頼方法）タイプ */
export const PurchaseType = {
  /** 入札 */
  Tendered: "1",
  /** 即決 */
  Prompted: "2",
} as const;

export type PurchaseType = typeof PurchaseType[keyof typeof PurchaseType];
